import * as Sentry from '@sentry/react';
import {
  Modal,
  ModalActions,
  ModalContent,
  Prose,
  Pushbutton
} from '@stratumn/atomic';
import to from 'await-to-js';
import { ROUTE_BOTS } from 'constant/routes';
import compose from 'lodash.flowright';
import { removeOrgBot } from 'mutations';
import PropType from 'prop-types';
import { useState } from 'react';
import injectSheet from 'react-jss';
import { generatePath, withRouter } from 'react-router-dom';
import { SpanType, withSpanAsync } from 'tracing';
import { withGqlClient } from 'wrappers';

import styles from './removeOrgBotModal.style';

export const RemoveOrgBotModal = ({
  classes,
  environment,
  bot,
  toggleModal,
  history
}) => {
  const [submitted, setSubmit] = useState(false);

  const { name, rowId, organization, teams } = bot;

  const removeBotOrg = () => {
    withSpanAsync('removeOrgBot', SpanType.processing, async () => {
      setSubmit(true);

      const [err] = await to(
        removeOrgBot(environment, rowId, organization.rowId)
      );

      if (err) {
        Sentry.captureException(err);
        setSubmit(false);
      } else {
        history.push(generatePath(ROUTE_BOTS, { orgId: organization.rowId }));
      }

      return {};
    });
  };

  const modalDescriptionText = `This action will remove **${
    name || rowId
  }** from **${organization.name}**${
    teams.totalCount > 0 ? ' and the following teams' : ''
  }`;

  return (
    <Modal
      closeButtonLabel="Cancel"
      handleCollapse={toggleModal}
      title="Remove from organization"
    >
      <ModalContent>
        <Prose light text={modalDescriptionText} />
        <ul className={classes.teamList}>
          {teams.nodes.map(n => (
            <li className={classes.teamListItems} key={n.id}>
              {n.name}
            </li>
          ))}
        </ul>
      </ModalContent>
      <ModalActions>
        <Pushbutton data-testid="cancel-button" onClick={toggleModal}>
          cancel
        </Pushbutton>
        <Pushbutton
          data-testid="remove-org-bot-button"
          disabled={submitted}
          onClick={removeBotOrg}
          warning
        >
          Remove from organization
        </Pushbutton>
      </ModalActions>
    </Modal>
  );
};

RemoveOrgBotModal.propTypes = {
  classes: PropType.object.isRequired,
  environment: PropType.object.isRequired,
  history: PropType.object.isRequired,
  bot: PropType.object.isRequired,
  toggleModal: PropType.func.isRequired
};

export default compose(
  withRouter,
  withGqlClient,
  injectSheet(styles)
)(RemoveOrgBotModal);
